import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";

import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";
import SubdirectoryArrowLeftIcon from "@mui/icons-material/SubdirectoryArrowLeft";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import SemProduto from "../../assets/img/produto-sem-imagem.jpg";

import styles from "./print-promi.module.css";
import { useState, useEffect, memo } from "react";
import { createPortal } from "react-dom";


const TableFormKit = (props) => {
    const {
        prodHandler,
        data,
        index,
        lenTable,
        handleRemoveDevolvido,
        formType,
        handleChangeReturn,
        handleChangeSoldProd,
        style, // 👉 vem do react-window
    } = props;

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isHovered, setIsHovered] = useState(false);
    const [hasError, setHasError] = useState(false);

    const formatNumber = (value) => {
        if (!value && value !== 0) return "-";
        return value.toLocaleString("pt-br", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    function formatDate(isoDate) {
        if (!isoDate) return " - ";
        const date = new Date(isoDate);
        if (Number.isNaN(date.getTime())) return " - ";

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    const getBackgroundColor = () => {
        if (data?.devolvido) return colors.blueAccent[500];
        if (data?.sold_prod || data?.sold_prod_db) return colors.greenReturned[100];
        return index % 2 ? colors.pink[400] : colors.pink[600];
    };

    const handleImageError = (event) => {
        event.target.src = SemProduto;
        setHasError(true);
    };

    const closeImage = () => {
        setIsHovered(false);
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            // 👉 só fecha no ESC, e só se tiver imagem grande aberta
            if (event.key === "Escape" && isHovered) {
                closeImage();
            }
        };

        window.addEventListener("keydown", handleKeyPress);
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, [isHovered]); // depende só do estado local

    const handleHover = () => {
        setIsHovered((prev) => !prev);
    };

    // console.log('datahere: ', data)

    return (
        <Box
            // 👇 o style que vem do react-window PRECISA ir no container raiz
            style={style}
            sx={{
                boxSizing: "border-box",
                padding: 0,
                margin: 0,
                width: "100%",
            }}

        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    width: "100%",

                    backgroundColor: getBackgroundColor(),
                    borderRadius: "2px",

                    // 🔥 linha mais compacta
                    padding: "4px 10px",
                    minHeight: index === lenTable - 1 ? "70px" : "54px",
                    alignItems: "center",

                    // 🔥 gap visual entre as linhas
                    marginBottom: "2px",
                    boxSizing: "border-box",
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(8, 2fr)",
                        gap: "20px",
                        width: "80%",
                        justifyContent: "flex-start",
                        alignItems: "center",
                    }}
                >
                    <span>{lenTable - index}</span>

                    <div className={styles.container} onClick={handleHover}>
                        {/* Miniatura */}
                        <Box
                            component="img"
                            src={data?.imageUrl || SemProduto}
                            alt={data?.id_produto}
                            className={styles.smallImage}
                            onError={handleImageError}
                        />

                        {/* IMAGEM GRANDE VIA PORTAL (FORA DA LISTA) */}
                        {isHovered && !hasError &&
                            createPortal(
                                <div
                                    className={styles.backdrop}
                                    onClick={() => setIsHovered(false)}
                                >
                                    <img
                                        src={data?.imageUrl || SemProduto}
                                        alt={data?.id_produto}
                                        className={styles.largeImage}
                                        onClick={(e) => e.stopPropagation()} // não fecha ao clicar na imagem
                                    />
                                </div>,
                                document.body
                            )}
                    </div>

                    <span>{data.model}</span>
                    <span>{data.id_produto}</span>
                    <span>{data?.tamanho ? data.tamanho : "-"}</span>
                    <span>{data.color__color}</span>
                    <span>R$ {formatNumber(data?.sell_price)}</span>
                    <span>{formatDate(data?.created_at)}</span>
                </Box>

                <Box
                    sx={{
                        marginLeft: "80px",
                        display: "flex",
                        alignItems: "baseline",
                        gap: 0.5,
                    }}
                >
                    {(data?.devolvido || data?.sold_prod || data?.sold_prod_db) && (
                        <IconButton
                            aria-label="remove-status"
                            size="small"
                            color="warning"
                            onClick={() => handleRemoveDevolvido(data.unit_id)}
                        >
                            <CancelIcon fontSize="inherit" />
                        </IconButton>
                    )}

                    {formType === "Editando" && data?.added_now && (
                        <Box
                            aria-label="delete-edited"
                            size="small"
                            color="error"
                            sx={{ cursor: "pointer" }}
                            onClick={() => prodHandler("deleteEdited", data.id_produto)}
                        >
                            <DeleteIcon
                                fontSize="inherit"
                                sx={{
                                    cursor: "pointer",
                                    color: "error.main",
                                    ":hover": { color: "error.dark" },
                                }}
                            />
                        </Box>
                    )}

                    {formType === "Criando" && (
                        <Box
                            aria-label="delete"
                            size="small"
                            color="error"
                            sx={{ cursor: "pointer" }}
                            onClick={() => prodHandler("delete", data.id_produto)}
                        >
                            <DeleteIcon
                                fontSize="inherit"
                                sx={{
                                    cursor: "pointer",
                                    color: "error.main",
                                    ":hover": { color: "error.dark" },
                                }}
                            />
                        </Box>
                    )}

                    {formType === "Editando" &&
                        !data?.devolvido &&
                        !data?.sold_prod &&
                        !data?.sold_prod_db && (
                            <IconButton
                                aria-label="set-return"
                                size="small"
                                color="warning"
                                sx={{ cursor: "pointer" }}
                                onClick={() => handleChangeReturn(data.id_produto, data.unit_id)}
                            >
                                <SubdirectoryArrowLeftIcon fontSize="inherit" />
                            </IconButton>
                        )}

                    {formType === "Editando" &&
                        !data?.devolvido &&
                        !data?.sold_prod &&
                        !data?.sold_prod_db && (
                            <IconButton
                                aria-label="set-sold"
                                size="small"
                                color="success"
                                sx={{ cursor: "pointer" }}
                                // onClick={() => handleChangeSoldProd(data.id_produto, data.unit_id)}
                                onClick={() => handleChangeSoldProd(data.unit_id)}

                            >
                                <ShoppingCartCheckoutIcon fontSize="inherit" />
                            </IconButton>
                        )}
                </Box>
            </Box>
        </Box>
    );
};

export default memo(TableFormKit);
